var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
              "show-print": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("audanet-task-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "article",
                  { staticClass: "box" },
                  [
                    _c(
                      "div",
                      { staticClass: "tags has-addons is-pulled-right" },
                      [
                        _c("span", { staticClass: "tag is-dark" }, [
                          _vm._v("Last fetched"),
                        ]),
                        !_vm.isTableLoading
                          ? _c("span", { staticClass: "tag is-success" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatDateTimeLocale(
                                    new Date(),
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary",
                        on: { click: _vm.filterList },
                      },
                      [_vm._m(0), _c("span", [_vm._v("Fetch")])]
                    ),
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.tasks, function (task, index) {
                          return _c(
                            "tr",
                            {
                              key: task.taskId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _vm._v(" " + _vm._s(task.claimNo) + " "),
                              ]),
                              _c("td", [
                                _vm._v(" " + _vm._s(task.displayName) + " "),
                              ]),
                              _c("td", [
                                _vm._v(" " + _vm._s(task.taskStatus) + " "),
                              ]),
                              _c("td", [
                                _vm._v(" " + _vm._s(task.taskType) + " "),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " + _vm._s(task.businessStatusText) + " "
                                ),
                              ]),
                              _c("td", [
                                _vm._v(" " + _vm._s(task.quoteNumbers) + " "),
                              ]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatDateTimeLocale(
                                        task.creationDate,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _vm.isAutoSyncEnabled
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$filters.formatDateTimeLocale(
                                            task.syncedDate,
                                            _vm.$userInfo.locale
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c("td", { staticClass: "is-content-width" }, [
                                _c(
                                  "div",
                                  { staticClass: "has-text-centered" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "tooltip is-tooltip-topright",
                                        attrs: {
                                          "data-tooltip": _vm.getIconToolTip(
                                            task.businessStatusText,
                                            _vm.audanetSetting
                                          ),
                                        },
                                      },
                                      [
                                        _vm.canLoadMessage
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "button is-success is-small is-inverted",
                                                attrs: {
                                                  disabled:
                                                    _vm.checkSettingStatus(
                                                      task.businessStatusText,
                                                      _vm.audanetSetting
                                                    ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    !_vm.checkSettingStatus(
                                                      task.businessStatusText,
                                                      _vm.audanetSetting
                                                    ) && _vm.load(index)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "icon is-medium",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "mdi mdi-download mdi-24px",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c(
            "load-quote-modal",
            {
              attrs: {
                active: _vm.isLoadQuoteModalActive,
                "show-icon": false,
                "previous-disabled":
                  _vm.currentStep === _vm.steps.CreateAssign.id,
                "next-disabled": _vm.currentStep === _vm.lastStep.id,
                "continue-disabled": !_vm.enableContinue,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isLoadQuoteModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                previous: function ($event) {
                  return _vm.previous()
                },
                next: function ($event) {
                  return _vm.next()
                },
                load: function ($event) {
                  return _vm.loadTask()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("AudaNet Load Task"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("load-quote-steps", {
                    attrs: {
                      "current-step": _vm.currentStep,
                      steps: _vm.steps,
                      "ecom-type": "audanet",
                    },
                    model: {
                      value: _vm.loadOptions,
                      callback: function ($$v) {
                        _vm.loadOptions = $$v
                      },
                      expression: "loadOptions",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isOverwriteModalActive,
                "ok-tooltip":
                  "Load but don't overwrite if Calculation IDs are the same",
                "cancel-tooltip":
                  "Load & overwrite even if Calculation IDs are the same",
                "ok-text": "Load",
                "cancel-text": "Load & Overwrite",
                "show-close": true,
                "close-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isOverwriteModalActive = $event
                },
                ok: _vm.overwriteOk,
                cancel: _vm.overwriteCancel,
                close: _vm.overwriteClose,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Overwrite Quote"),
              ]),
              _c(
                "section",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.isOverwriteModalActive
                    ? _c("div", [
                        _c("p", [_vm._v("Found matching quote with")]),
                        _c("br"),
                        _c("p", { staticStyle: { "margin-left": "2em" } }, [
                          _vm._v(" Quote No.: "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "has-text-primary has-text-weight-bold",
                            },
                            [_vm._v(_vm._s(_vm.quoteSummaries.quoteNoRef))]
                          ),
                          _c("br"),
                          _vm._v("Calc Id: "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "has-text-primary has-text-weight-bold",
                            },
                            [_vm._v(_vm._s(_vm.quoteSummaries.calculationId))]
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" Overwrite quote? "),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isGotoModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isGotoModalActive = $event
                },
                ok: function ($event) {
                  return _vm.gotoQuote(true)
                },
                cancel: function ($event) {
                  return _vm.gotoQuote(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Go to Quote"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.quoteSummaries !== null &&
                  _vm.quoteSummaries.isCreateQuote
                    ? _c("span", [_vm._v("Quote created.")])
                    : _c("span", [_vm._v("Quote updated.")]),
                  _vm._v(" Go to quote "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.quoteNo}`))]
                  ),
                  _vm._v(" now? "),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isCreateSubQuoteModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isCreateSubQuoteModalActive = $event
                },
                ok: function ($event) {
                  return _vm.createSubQuote(true)
                },
                cancel: function ($event) {
                  return _vm.createSubQuote(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Create Supplementary Quote"),
              ]),
              _c(
                "section",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm.isCreateSubQuoteModalActive
                    ? _c("div", [
                        _c("p", [
                          _vm._v("Found new supplementary quote added in "),
                          _vm.selectedTask.taskType ===
                          _vm.audaNetTaskTypes.AudaBridge
                            ? _c("span", [_vm._v("AudaBridge")])
                            : _c("span", [_vm._v("AudaNet")]),
                        ]),
                        _c("br"),
                        _c("p", { staticStyle: { "margin-left": "2em" } }, [
                          _vm._v(" Quote No.: "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "has-text-primary has-text-weight-bold",
                            },
                            [_vm._v(_vm._s(_vm.quoteSummaries.quoteNoRef))]
                          ),
                          _c("br"),
                          _vm._v("Current Supp: "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "has-text-primary has-text-weight-bold",
                            },
                            [_vm._v(_vm._s(_vm.quoteSummaries.subQuoteNo))]
                          ),
                          _c("br"),
                          _vm._v("New supp: "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "has-text-primary has-text-weight-bold",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.quoteSummaries.createSubQuoteNo)
                              ),
                            ]
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" Create new supplementary quote? "),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-cloud-download mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }